import React,{useState} from 'react';
import "./Login.css";
import {Link,useHistory} from "react-router-dom";
import {auth} from "./firebase";
function Login() {
    const history = useHistory();
    const [email,setEmail] = useState('');
    const [password,setPassword] = useState('');
    const login = (event)=>{
        event.preventDefault();
        auth.signInWithEmailAndPassword(email,password)
        .then((auth)=>{
            history.push('/');

        })
        .catch((e)=>alert(e.message));




    };
    const register = (event)=>{
        event.preventDefault(); 
        auth.createUserWithEmailAndPassword(email,password)
         .then(auth=>{
            history.push('/');
         })
         .catch((e)=>alert(e.message));

    };
    return (
     
        <div className="login">
            <Link to ="/">
                <img
                className ="login_logo"
                src = "http://pngimg.com/uploads/amazon/amazon_PNG11.png"
                alt = ""
            />
            </Link>
         
      

        <div className="login_container">
            <h1> Sign in</h1>
            <form>
            <h5> Email</h5>
            <input value={email} onChange={event => setEmail(event.target.value)} type = "email" />
            <h5> Password</h5>
            <input value={password} onChange = {event=> setPassword(event.target.value)} type = "password" />
            <button type="submit" onClick={login} className = "login_signinb"> Sign in</button>
            </form>
            <p>
                By sign in you agree to Amazon's conditions of
                 see our privacy notice, Our cookies Notice ans our 
                 cookies Notice and our Interest Based Ads Notice.
            </p>
            <button  type="submit" onClick={register} className = "login_regb"> Create your Amazon Account</button>
            </div>
        </div>
     );
}
export default Login
